<template>
    <tr>
        <td class="p-1 p-sm-3">
            {{ invoice.order_date }}
        </td>
        <td class="p-1 p-sm-3">
            {{ invoice.order_label }}
        </td>
        <td class="p-1 p-sm-3">
            {{ invoice.order_due_date }}
        </td>
        <td class="p-1 p-sm-3">
            {{ invoice.amount_formatted }}
        </td>
        <td class="p-1 p-sm-3">
            {{ invoice.readable_payment_status }}
        </td>
        <td class="p-1 p-sm-3 text-center">
            <a class="btn btn-primary btn-sm" target="_blank" :href="downloadLink"><span class="fas fa-download"></span> {{ $t('Last ned') }}</a>
        </td>
    </tr>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps(['invoice', 'isApp', 'hashedKey'])

const downloadLink = computed(() => {
    return '/document/' + props.invoice.id + '?aoh=1' + (props.isApp ? '&auth=' + props.hashedKey : '')
})
</script>

<style scoped>

</style>